import React, {useContext} from "react";
import {CardFooter} from "@material-tailwind/react";
import {Paginator} from "./paginator";
import {PaginateContext} from "../../context/paginate";

export function CardFooterPaginator() {

  const {
    active,
    setActive,
    totalRows,
    rowsCount,
    setRowsCount,
    from,
    to,
  } = useContext(PaginateContext)

  return (
    <CardFooter className="flex items-center justify-center border-t border-app-border bg-app-surface p-4 text-app-text">
      <Paginator
        active={active}
        setActive={setActive}
        totalRows={totalRows}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        from={from}
        to={to}
      />
    </CardFooter>
  );
}
